<div data-testid="autocomplete-result" (click)="buttonpressed()"><ng-content></ng-content></div>
